<!-- 图文信息分页Tab查询展示列表：模块头+图片+查询Tab+标题+分页 -->
<template>
<div class="content-block">
  <div class="info-list-title" v-if="showTitle">
    <span>{{title}}</span>
    <label>{{label}}</label>
    <a href="#" v-if="showMore">更多</a>
    <div class="title-search-div"  v-if="showSearch">
      <input type="text" name="title-search" class="title-search-input" vaule="" /><a href="javascript(0)" class="title-search-button"></a>
    </div>
  </div>
  <div class="info-list-content">
    <ul class="list-tab-search-ul" v-if="tabList.length>0">
      <li v-for="(tab, index) in tabList" v-bind:class="['list-tab-search-li',tab.type==selectTab ?'li-active' : '']" v-on:click="selectedAct(tab.type)">{{tab.title}}</li>
    </ul>
    <div class="list-tab-search-detail" v-if="showTagSearch">
        <table class="search-detail-table" cellspacing="0px" border="0px" rules="rows">
          <tr>
            <td class="search-title">分类:</td>
            <td>
              <a v-for="(filter, index) in filterList" v-bind:class="['search-detail',index==selectFilter ?'li-active' : '']" v-on:click="selectedFilter(index,filter.code)">{{filter.title}}</a>
            </td>
          </tr>
        </table>
    </div>
    <ul  class="list-order-ul" v-if="showOrder">
      <li class="list-order-li-label">排序：</li>
      <li class="list-order-li">最热门</li>
      <li class="list-order-li">综合</li>
      <li class="list-order-li">最新</li>
      <li class="list-order-li">面积</li>
      <li class="list-order-li">价格</li>
      <li class="list-order-li-search">
          <input type="text"><span>-</span><input type="text"><a>确定</a>
      </li>
      <li class="list-order-li-total">找到相关仓库83个<1/9></li>
    </ul>
    <ul>
      <li v-for="info in infoPage.list">
          <component :is="infoBlock" :info="info"/></component>
      </li>
    </ul>
    <pagination :page="infoPage"  v-on:queryData="queryPage"/>
  </div>
</div>
</template>

<script>
import Pagination from '../utils/Pagination'

export default {
  name: 'InfoPageList01',
  components:{'pagination':Pagination},
  props: {
    showTitle: {
      type: Boolean,
      default: false
    },
    showMore: {
      type: Boolean,
      default: true
    },
    showSearch: {
      type: Boolean,
      default: false
    },
    showTagSearch:{
      type: Boolean,
      default: false
    },
    showOrder: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    titleLength: {
      type: String,
      default: '16'
    },
    label: {
      type: String,
      default: ''
    },
    count: {
      type: String,
      default: '3'
    },
    tabList: {
      type:Array,
      default:function(){return []}
    },
    tabDefaultType: {
      type:String,
      default:'1'
    },
    tabClass: {
      type:String,
      default:'list-tab-ul'
    },
    filterList:{
      type:Array,
      default:function(){return []}
    },
    infoBlock:{
      type:Object,
      default:{}
    },
    infoPage:{
      type:Object,
      default:function(){return {list:[],total:0}}
    }
  },
  data() {
    return {
      selectTab:this.tabDefaultType,
      selectFilter:-1,
      //newsList:[],
      params: {page:1,pageSize:this.count,type:this.tabDefaultType,keyWord:''}
    }
  },
  methods:{
    selectedAct:function(type){
      this.selectTab=type;
      this.params.type=type;
      this.params.page=1;
      this.params.total=0;
      this.$emit("queryPage",this.params);
    },
    selectedFilter:function(index,code){
      this.selectFilter=index;
      this.params.code=code;
      this.params.page=1;
      this.params.total=0;
      this.$emit("queryPage",this.params);
    },
    tabDetailSearch:function(){
      this.params.keyWord=this.keyWord;
      this.params.page=1;
      this.$emit("queryPage",this.params);
    },
    queryPage:function(params){
      //console.log("查询分页数据："+JSON.stringify(params));
      this.params=params;
      this.$emit("queryPage",params);
    }
  },
  created:function(){
    //this.newsList=this.Global.newsListDemo.slice(0,this.count);
    //console.log("当前导航页："+this.Global.siteDefaultNav);
    this.queryPage(this.params);
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display:block;
  position:relative;
  margin: 0px 0px 0px 0px;
  padding:0px;
  height:100%;
  text-align:left;
  //background:red;
}
.title-search-div{
  position:relative;
  float:right;
  height:30px;
  width:260px;
  background:green;
  bottom:-10px;
}

.title-search-div .title-search-input {
  display: block;
  float: left;
  width: 220px;
  height: 30px;
  outline-style: none;
  border: 1px solid #dbdbdb;
  font-size: 14px;
  padding-left: 5px;
  background:#dbdbdb;
}

.title-search-div .title-search-button {
  display: block;
  float: left;
  width: 40px;
  height: 30px;
  text-decoration: none;
  background: #515151;
  font-size: 12px;
  color:#ffffff;
  text-align: center;
  line-height: 30px;
  letter-spacing:5px;
  background-image:url(./../../assets/search_1.png);
  background-size: 15px 15px;
  background-repeat: no-repeat;
  background-position: center center;
}

.list-tab-search-ul {
  display:flex;
  justify-content:flex-start;
  margin: 5px 0px 5px 0px;
  width:100%;
  height:40px;
  text-align:center;
  list-style-type: none;
  padding: 5px;
  background:#eee;
}

.list-tab-search-detail{
  position:relative;
  width:100%;
  height:100%;
  background:#fff;
  border:1px solid #eee;
  margin-bottom:5px;
}

.search-detail-table{
  width:100%;
  text-align:left;
  border-color:#eee;
  border-width:1px;
  //border-bottom:0px;
}

.search-detail-table td{
  height:40px;
  padding-left:10px;
}

.search-detail{
  margin-right:10px;
}

.search-detail:hover{
  color:var(--color6);
  cursor: pointer;
}

.list-order-ul{
  display:flex;
  justify-content:flex-start;
  margin: 10px auto;
  width:100%;
  height:40px;
  text-align:center;
  list-style-type: none;
  padding: 5px;
  background:#eee;
}

.list-tab-ul-1 {
  display:flex;
  justify-content:flex-start;
  margin: 10px auto;
  width:100%;
  height:50px;
  text-align:center;
  list-style-type: none;
  padding: 5px 5px 15px 5px;
  border-bottom:1px solid #bbb;
}


.list-tab-search-li {
  float: left;
  margin: 0px 10px 0px 10px;
  height: 30px;
  width: 100px;
  color: #000000;
  font-size: 12px;
  line-height: 30px;
  text-align: center;
  background: #598118-#BE550F;
}

.list-order-li-label {
  float: left;
  margin: 0px 10px 0px 10px;
  height: 30px;
  width: 40px;
  color: #000000;
  font-size: 12px;
  font-weight: 300;
  line-height: 30px;
  text-align: left;
  background: #598118-#BE550F;
}

.list-order-li {
  float: left;
  margin: 0px 5px 0px 5px;
  height: 30px;
  width: 50px;
  color: #000000;
  font-size: 12px;
  font-weight: 300;
  line-height: 30px;
  text-align: center;
  background: #598118-#BE550F;
}

.list-order-li-total {
  float: left;
  right:0px;
  margin: 0px 5px 0px 5px;
  height: 30px;
  width: 150px;
  color: #000000;
  font-size: 12px;
  font-weight: 300;
  line-height: 30px;
  text-align: center;
}

.list-order-li-search {
  float: right;
  right:0px;
  margin: 0px 5px 0px 5px;
  height: 30px;
  width: 200px;
  color: #000000;
  font-size: 12px;
  font-weight: 300;
  line-height: 30px;
  text-align: center;
}

.list-order-li-search input{
  display: block;
  float:left;
  height: 25px;
  width: 60px;
  color: #000000;
  font-size: 12px;
  font-weight: 300;
  line-height: 25px;
  text-align: left;
  border:0px;
  margin-top:3px;
}

.list-order-li-search span{
  display: block;
  float:left;
  height: 25px;
  width: 10px;
  font-size: 12px;
  font-weight: 300;
  line-height: 25px;
  margin-top:3px;
}

.list-order-li-search a{
  display: block;
  float:left;

  width: 40px;
  height: 25px;
  text-decoration: none;
  background: #598118;
  font-size: 12px;
  color:#ffffff;
  text-align: center;
  line-height: 25px;
  letter-spacing:2px;
  margin-left:5px;
  margin-top:3px;
}

.list-tab-search-li:hover{
  cursor: pointer;
  background:#bbb;
  color:#000;
}

.list-order-li:hover{
  cursor: pointer;
  background:#bbb;
  color:#000;
}

.li-active{
  color: #ffffff;
  background: #598118;
  background: -moz-linear-gradient(left,  #598118 50%, #BE550F 100%);
  background: -webkit-gradient(linear, left top, left bottom, color-stop(50%,#BE550F), color-stop(100%,#BE550F));
  background: -webkit-linear-gradient(left,  #598118 f0%,#BE550F 100%);
  background: -o-linear-gradient(left,  #598118 f0%,#BE550F 100%);
  background: -ms-linear-gradient(left,  #598118 f0%,#BE550F 100%);
  background: linear-gradient(to right,  #598118 f0%,#BE550F 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#598118', endColorstr='#BE550F',GradientType=0 );
}

</style>



// WEBPACK FOOTER //
// src/components/block/InfoPageList03.vue